import { comma } from 'src/utils/comma';
import styles from './index.module.scss';

type Props = {
  price: number;
  currency: string;
};

export const PriceWithLocalCurrency: React.FC<Props> = ({ price, currency }) => {
  return (
    <div className={styles.container}>
      <span className={styles.currency}>{currency}</span>
      {comma(price)}
    </div>
  );
};
